import React, { useMemo } from 'react'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import { FlowChartIcon } from 'common/builder/components/chart/FlowChart/types/FlowChartIcon'

import * as styles from './StartingStepHeader.styles'

interface LargeNodeHeaderContentProps {
  title: string
  icon: FlowChartIcon
}

export const StartingStepHeader = ({
  icon: { icon, size, color },
  title,
}: LargeNodeHeaderContentProps) => {
  const iconString = useMemo(() => convertToIconString(icon, { size, color }), [color, icon, size])

  return (
    <view style={styles.Wrapper}>
      <sprite image={iconString} style={styles.MainIcon} />
      <richtext style={styles.TitleStyle} text={title} />
    </view>
  )
}
